interface props{
    style?: any;
}
function Loader(props: props) {
    const {style} = props;
    return (
        <div className="loader__wrapper" style={style}>
            <div className="loader" ><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div >
        </div>
    );
}

export default Loader;